<template>
  <div class="waiting-list-subscribe">
    <h2>{{ t('registration.waitingList.title', 'Request an invitation code') }}</h2>
    <p class="description">
      {{ t('registration.waitingList.description', 'Enter your email to join the waiting list. We will send you an invitation code when registration becomes open to new entrants.') }}
    </p>
    <form
      @submit.prevent="handleSubmit"
      class="waiting-list-form"
    >
      <div class="form-group">
        <label for="waiting-list-email">{{ t('registration.waitingList.emailLabel', 'Email') }} *</label>
        <input
          id="waiting-list-email"
          v-model="email"
          type="email"
          required
          :disabled="isSubmitting || isSuccess"
          :placeholder="t('registration.waitingList.emailPlaceholder', 'your email address')"
          :class="{ 'input-error': errorMessage }"
        >
        <div
          v-if="errorMessage"
          class="error-message"
        >
          {{ errorMessage }}
        </div>
        <div
          v-if="isSuccess"
          class="success-message"
        >
          {{ t('registration.waitingList.success', 'Thank you! You have been added to the waiting list.') }}
        </div>
        <div
          v-if="displayTotalWaitingList()"
          class="total-waiting-list"
        >
          {{ t('registration.waitingList.total', 'Total on waiting list:') }} {{ totalWaitingList }}
        </div>
      </div>
      <div class="form-actions">
        <button
          type="submit"
          class="btn-primary"
          :disabled="isSubmitting || isSuccess"
        >
          {{ isSubmitting ? t('registration.waitingList.submitting', 'Subscribing...') : t('registration.waitingList.submit', 'Request code') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { r7eBaseApp } from '../services/index.js';

const { t } = useI18n();

const product = computed(() => (r7eBaseApp.account_type || 'recognyze')+ '.code');

const email = ref('');
const isSubmitting = ref(false);
const isSuccess = ref(false);
const errorMessage = ref('');
const totalWaitingList = ref(0);

const emit = defineEmits(['subscribed']);

function displayTotalWaitingList() {
  return totalWaitingList.value >= 100; // (r7eBaseApp.minWaitingListTotal() || totalWaitingList.value > 3);
}

async function handleSubmit() {
  errorMessage.value = '';
  if (!email.value?.trim()) return;

  isSubmitting.value = true;
  try {
    const response = await r7eBaseApp.subscribeToWaitingList(email.value.trim(), product.value);
    console.log("response", response);
    totalWaitingList.value = response?.total;
    isSuccess.value = true;
    emit('subscribed');
  } catch (err) {
    console.log("err", err);
    console.log(err.data);
    console.log(err.message);

    const msg = err.response?.data?.message || err.response?.data?.error || err.message || t('registration.waitingList.error', 'Failed to subscribe. Please try again.');
    errorMessage.value = msg;
    totalWaitingList.value = err.response?.data?.total || 0;
  } finally {
    isSubmitting.value = false;
  }
}
</script>

<style scoped>
.waiting-list-subscribe {
  max-width: 400px;
  margin: 0 auto;
  padding: 1.5rem;
}

.waiting-list-subscribe h2 {
  color: var(--color-text-dark);
  margin-bottom: 0.75rem;
  font-size: 1.5em;
}

.description {
  color: var(--color-text);
  font-size: 1em;
  line-height: 1.5;
  margin-bottom: 1.5rem;
}

.waiting-list-form .form-group {
  margin-bottom: 1rem;
}

.waiting-list-form label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--color-text-dark);
  font-weight: 500;
}

.waiting-list-form input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  font-size: 1em;
}

.waiting-list-form input.input-error {
  border-color: var(--color-error, #dc3545);
}

.waiting-list-form input:disabled {
  background-color: var(--color-frame-bg);
  cursor: not-allowed;
}

.error-message {
  color: var(--color-error, #dc3545);
  font-size: 0.9em;
  margin-top: 0.5rem;
}

.success-message {
  color: var(--color-safe, #28a745);
  font-size: 0.95em;
  margin-top: 0.5rem;
}

.form-actions {
  margin-top: 1.25rem;
}

.btn-primary {
  padding: 0.75rem 1.5rem;
  background-color: var(--color-safe);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1em;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover:not(:disabled) {
  opacity: 0.9;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.total-waiting-list {
  color: var(--color-text);
  font-size: 0.9em;
  margin-top: 0.5rem;
  text-align: center;
  font-weight: 500;
  font-size: 1em;
  line-height: 1.5;
  margin-bottom: 1.5rem;
}
</style>
